import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eac1b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_6 = { class: "ss-tela-titulo" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Sincronizar Ambientes", -1))
const _hoisted_8 = { class: "atalhos" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1))
const _hoisted_10 = {
  style: {"color":"orange","font-size":"20px"},
  class: "anticon"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1))
const _hoisted_12 = { class: "anticon" }
const _hoisted_13 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-5",
  style: {"padding-top":"4px","padding-right":"20px"}
}
const _hoisted_14 = { class: "ant-btn-group ss-tamanho-completo" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Iniciar sincronização", -1))
const _hoisted_16 = { class: "ss-tela-conteudo" }
const _hoisted_17 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_20 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = { key: 2 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_30 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-16"
}
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_33 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_39 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_40 = { class: "ant-input-group-addon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_selecionar_item_sincronizar_ambiente = _resolveComponent("selecionar-item-sincronizar-ambiente")!
  const _component_selecionar_acao_nao_selecionados_sincronizar_ambiente = _resolveComponent("selecionar-acao-nao-selecionados-sincronizar-ambiente")!
  const _component_selecionar_estado = _resolveComponent("selecionar-estado")!
  const _component_selecionar_cidade = _resolveComponent("selecionar-cidade")!
  const _component_selecionar_plano_assinatura = _resolveComponent("selecionar-plano-assinatura")!
  const _component_selecionar_banco = _resolveComponent("selecionar-banco")!
  const _component_selecionar_ncm = _resolveComponent("selecionar-ncm")!
  const _component_selecionar_cfop = _resolveComponent("selecionar-cfop")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_ambiente = _resolveComponent("selecionar-ambiente")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_9
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas)))
                        }, [
                          _createElementVNode("i", _hoisted_10, [
                            _createVNode(_component_icone, { nome: "estrela" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 1,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas)))
                        }, [
                          _createElementVNode("i", _hoisted_12, [
                            _createVNode(_component_icone, { nome: "favorito" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.permitirSincronizacao())
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.iniciarSincronizacao())),
                    style: {"width":"100%"},
                    class: "ant-btn ant-btn-primary ss-btn-tela ss-tamanho-completo"
                  }, [
                    _createVNode(_component_icone, { nome: "correto" }),
                    _hoisted_15
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.state.todosRecursos,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.todosRecursos) = $event)),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.estrategiaDefinirRecursos())),
                      "button-style": "solid"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_button, { value: true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Todos Recursos")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio_button, { value: false }, {
                          default: _withCtx(() => [
                            _createTextVNode("Recursos Especifícos")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ]),
                ((!_ctx.state.todosRecursos))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_a_form_item, {
                          label: "Escolha um recurso que deseja sincronizar",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.state.recursoSelecionado,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.recursoSelecionado) = $event)),
                              "show-search": "",
                              allowClear: true,
                              placeholder: "",
                              style: {"width":"100%"},
                              "filter-option": false,
                              options: _ctx.state.listaRecursos
                            }, null, 8, ["value", "options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_a_form_item, {
                          label: " ",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-block",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.adicionarSincronizacao(_ctx.state.recursoSelecionado)))
                            }, _hoisted_24)
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_25,
                (_ctx.state.dados.length <= 0)
                  ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                      key: 1,
                      mensagem: "Nenhuma recurso foi definido"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(_component_a_divider, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Dados para Sincronizar")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.dados, (sincronizacao, index) => {
                        return (_openBlock(), _createBlock(_component_card, {
                          key: index,
                          titulo: (index + 1) + 'ª Sincronização'
                        }, {
                          AcoesExtra: _withCtx(() => [
                            ((!_ctx.state.todosRecursos))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "ss-fonte-negrito ss-card-botao-acao-extra-secundaria",
                                  title: "Remover",
                                  onClick: ($event: any) => (_ctx.removerSincronizacao(index))
                                }, "Remover ", 8, _hoisted_27))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_a_form_item, {
                                  label: "Recurso",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select, {
                                      value: sincronizacao.recurso,
                                      "onUpdate:value": ($event: any) => ((sincronizacao.recurso) = $event),
                                      disabled: true,
                                      "show-search": "",
                                      allowClear: true,
                                      placeholder: "",
                                      style: {"width":"100%"},
                                      "filter-option": false,
                                      options: _ctx.state.listaRecursos
                                    }, null, 8, ["value", "onUpdate:value", "options"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              (sincronizacao.recurso === 'TABELA_IBPT')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createVNode(_component_a_alert, {
                                      message: "As tabelas de todos os estados serão atualizadas.",
                                      type: "info",
                                      "show-icon": ""
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Quais registros?",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_item_sincronizar_ambiente, {
                                            radioButton: true,
                                            valor: sincronizacao.selecaoItens,
                                            "onUpdate:valor": ($event: any) => ((sincronizacao.selecaoItens) = $event)
                                          }, null, 8, ["valor", "onUpdate:valor"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createVNode(_component_a_form_item, {
                                        label: "O que fazer com os registros não selecionados",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_acao_nao_selecionados_sincronizar_ambiente, {
                                            valor: sincronizacao.acaoNaoSelecionados,
                                            "onUpdate:valor": ($event: any) => ((sincronizacao.acaoNaoSelecionados) = $event)
                                          }, null, 8, ["valor", "onUpdate:valor"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ], 64))
                            ]),
                            ((sincronizacao.selecaoItens === _ctx.ESelecaoItemSincronizarAmbiente.ItensEspecificos))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Selecione os registros que deseja sincronizar",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        ((sincronizacao.recurso === 'CADASTRO_ESTADOS'))
                                          ? (_openBlock(), _createBlock(_component_selecionar_estado, {
                                              key: 0,
                                              varios: true,
                                              codigosSelecionados: sincronizacao.codigos,
                                              "onUpdate:codigosSelecionados": ($event: any) => ((sincronizacao.codigos) = $event)
                                            }, null, 8, ["codigosSelecionados", "onUpdate:codigosSelecionados"]))
                                          : _createCommentVNode("", true),
                                        ((sincronizacao.recurso === 'CADASTRO_CIDADES'))
                                          ? (_openBlock(), _createBlock(_component_selecionar_cidade, {
                                              key: 1,
                                              varios: true,
                                              codigosSelecionados: sincronizacao.codigos,
                                              "onUpdate:codigosSelecionados": ($event: any) => ((sincronizacao.codigos) = $event)
                                            }, null, 8, ["codigosSelecionados", "onUpdate:codigosSelecionados"]))
                                          : _createCommentVNode("", true),
                                        ((sincronizacao.recurso === 'CADASTRO_PLANOS_ASSINATURA'))
                                          ? (_openBlock(), _createBlock(_component_selecionar_plano_assinatura, {
                                              key: 2,
                                              varios: true,
                                              codigosSelecionados: sincronizacao.codigos,
                                              "onUpdate:codigosSelecionados": ($event: any) => ((sincronizacao.codigos) = $event)
                                            }, null, 8, ["codigosSelecionados", "onUpdate:codigosSelecionados"]))
                                          : _createCommentVNode("", true),
                                        ((sincronizacao.recurso === 'CADASTRO_BANCOS'))
                                          ? (_openBlock(), _createBlock(_component_selecionar_banco, {
                                              key: 3,
                                              varios: true,
                                              codigosSelecionados: sincronizacao.codigos,
                                              "onUpdate:codigosSelecionados": ($event: any) => ((sincronizacao.codigos) = $event)
                                            }, null, 8, ["codigosSelecionados", "onUpdate:codigosSelecionados"]))
                                          : _createCommentVNode("", true),
                                        ((sincronizacao.recurso === 'CADASTRO_NCMS'))
                                          ? (_openBlock(), _createBlock(_component_selecionar_ncm, {
                                              key: 4,
                                              varios: true,
                                              codigosSelecionados: sincronizacao.codigos,
                                              "onUpdate:codigosSelecionados": ($event: any) => ((sincronizacao.codigos) = $event)
                                            }, null, 8, ["codigosSelecionados", "onUpdate:codigosSelecionados"]))
                                          : _createCommentVNode("", true),
                                        ((sincronizacao.recurso === 'CADASTRO_CFOPS'))
                                          ? (_openBlock(), _createBlock(_component_selecionar_cfop, {
                                              key: 5,
                                              varios: true,
                                              codigosSelecionados: sincronizacao.codigos,
                                              "onUpdate:codigosSelecionados": ($event: any) => ((sincronizacao.codigos) = $event)
                                            }, null, 8, ["codigosSelecionados", "onUpdate:codigosSelecionados"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["titulo"]))
                      }), 128)),
                      _createVNode(_component_a_divider, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Defina os Ambientes e E-mail para notificação")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_a_form_item, {
                            label: "Ambientes",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_ambiente, {
                                varios: true,
                                codigosSelecionados: _ctx.state.sincronizacao.ambientes,
                                "onUpdate:codigosSelecionados": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.sincronizacao.ambientes) = $event))
                              }, null, 8, ["codigosSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_a_form_item, {
                            label: "E-mail para notificação",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_39, [
                                _createElementVNode("span", _hoisted_40, [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone",
                                    nome: "email"
                                  })
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.sincronizacao.email) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.sincronizacao.email]
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
            retornoRequisicao: _ctx.modalBase.retornoRequisicao
          }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
        ])
      ])
    ])
  ]))
}